import * as React from "react";
import { Link } from "react-router-dom";
import { DefaultVitalographLogo } from "../Core/VitalographLogo";

export const SignedOut = () => {
    return (
        <div className="middle-box text-center">
            <div>
                <div>

                    <h1 id="logo" className="logo-name">
                        <img src={`data:image/png;base64,${DefaultVitalographLogo}`} alt="Vitalograph Logo" />
                    </h1>

                </div>
                <h3 id="logoutTitle">Account Signed Out</h3>
                <p>
                    You have successfully signed out of your account.
                </p>
                <p>
                <Link id="signInLink" to="/account/signin">Click here to sign in.</Link>
                </p>
            </div>
        </div>
    );
}
